export enum SurveyFieldType {
    MultilineText = 0,
    IntNumber = 1,
    MultiOptions = 2,
    Scale = 3,
    Date = 4,
    SingleLineText = 5,
}

export interface SurveyFieldDefinitionData {
    label: string;
    type: SurveyFieldType;
    isMandatory: boolean;
    options?: string[];
    scaleMin?: number;
    scaleMax?: number;
}

export interface SurveySettingsData {
    id: string;
    name: string;
    description?: string;
    creationDate?: string;
    emailSubject?: string;
    emailHtml?: string;
    emailFromName?: string;
    emailFrom?: string;
    fields: SurveyFieldDefinitionData[];
    automaticForServiceTypeIds?: string[];
    isDefaultAutomaticSurvey?: boolean;
    whatsAppEnabled?: boolean;
    autoCreateClientIfNotExists?: boolean;
    totalSent?: number;
    totalResponses?: number;
}

export interface SurveyDraftData extends Omit<SurveySettingsData, 'id'> {
    id?: string;
}

export interface GenerateSurveyRequest {
    prompt: string;
    template?: SurveyDraftData;
}

export interface SendSurveyToContactRequest {
    channel?: 'email' | 'whatsapp';
    name?: string;
    email?: string;
    phoneNumber?: string;
}

export interface SurveyAnalyticsResponse {
    id: string;
    creationDate: string;
    isAnonymous: boolean;
    clientName?: string;
    professionalName?: string;
    serviceTypeName?: string;
    roomName?: string;
    branchName?: string;
    values: Record<string, string>;
}

export interface SurveyUpdateRequest {
    name: string;
    description?: string;
    emailSubject?: string;
    emailHtml?: string;
    emailFromName?: string;
    emailFrom?: string;
    fields: SurveyFieldDefinitionData[];
    automaticForServiceTypeIds?: string[];
    isDefaultAutomaticSurvey?: boolean;
    whatsAppEnabled?: boolean;
    autoCreateClientIfNotExists?: boolean;
}

export interface SurveyTokenData {
    survey: SurveySettingsData;
    clientName: string;
    companyName: string;
    companyImage?: string;
    appointmentDate: string;
    appointmentTime: string;
    professionalName: string;
    appointmentType: string;
    alreadyResponded: boolean;
    existingValues?: Record<string, string>;
}

export interface SurveyAnalyticsDimensionMetric {
    id: string;
    label: string;
    totalResponses: number;
    average: number;
}

export interface SurveyAnalyticsFieldResult {
    key: string;
    label: string;
    type: SurveyFieldType;
    average?: number;
    optionCounts?: Record<string, number>;
    textResponses?: string[];
    averageByProfessional: SurveyAnalyticsDimensionMetric[];
    averageByServiceType: SurveyAnalyticsDimensionMetric[];
    averageByRoom: SurveyAnalyticsDimensionMetric[];
}

export interface SurveyAnalyticsData {
    totalResponses: number;
    fields: SurveyAnalyticsFieldResult[];
    responses?: SurveyAnalyticsResponse[];
}
